<template>
    <div class="md-banner share-box">
        <a
            class="item iconfont"
            target="_blank"
            v-for="(item, index) in sharesInfo"
            :key="index"
            :class="{
                [item.icon]: true
            }"
            :href="item.url"
            :aria-label="item.socialNetwork"
            rel="noopener noreferrer"
        ></a>
    </div>
</template>

<script>
export default {
    name: 'AgentShare',
    props: {
        socialNetworks: {
            type: Array
        }
    },
    computed: {
        sharesInfo() {
            return this.socialNetWorkToIcon(this.socialNetworks || []);
        }
    },
    methods: {
        socialNetWorkToIcon(socialNetworks) {
            let shareLinks = socialNetworks.filter(item => {
                item.icon = 'icon-' + item.socialNetwork;
                if (item.socialNetwork === 'facebook') {
                    item.icon = 'icon-facebook-sign';
                }
                if (item.socialNetwork === 'google+') {
                    item.icon = 'icon-google1';
                }
                if (item.socialNetwork === 'twitter') {
                    item.icon = 'icon-newnewtwitter';
                }
                return !!item.socialNetwork && !!item.url;
            });
            return shareLinks;
        }
    }
};
</script>

<style lang="scss">
.md-banner.share-box {
    float: left;
    margin-top: 10px;
    @media (max-width: 900px) {
        margin-top: 15px;
    }
    display: flex;
    flex-wrap: wrap;
    .iconfont {
        margin: 0 12px 10px 0;
        color: #fff;
        width: 17px;
        height: 17px;
        font-size: 17px;
        margin: 10px;
        font-size: 20px;
    }
}
</style>
